// requireAuth.jsx
import { Navigate } from 'react-router-dom';

const requireAuth = (element, isAuthenticated, allowedRoles, userRole) => {
    if (!isAuthenticated) {
        return <Navigate to="/" />;
    }

    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/no-access" />;
    }

    return element;
};

export default requireAuth;